import { Suspense } from 'react';
import { Center, Loader } from '@mantine/core';

const SuspensedView = ({ children }: { children: React.ReactNode }) => {
  return (
    <Suspense
      fallback={
        <Center h="100vh">
          <Loader color="principal" type="bars" />
        </Center>
      }
    >
      {children}
    </Suspense>
  );
};

export { SuspensedView };
